import { DatePicker, message, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { ITaskOrderArchive } from "../../types/archiveTaskOrder.type";
import dayjs from "dayjs";
import { api } from "../../api/api";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveTaskOrder() {
  const [orders, setOrders] = useState<ITaskOrderArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchOrders = async () => {
    setLoading(true);

    try {
      const response = await api.get("/archive/task-orders", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YYYY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YYYY") : undefined,
        },
      });

      setOrders(response.data.orders);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error fetching orders", error);
      message.error("Ошибка при получение заказов");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Дата приёма",
      dataIndex: "admissionDate",
      key: "admissionDate",
      fixed: "left" as "left",
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      fixed: "left" as "left",
    },
    {
      title: "Продукция",
      dataIndex: "produceName",
      key: "produceName",
      fixed: "left" as "left",
    },
    {
      title: "Ед.измерения",
      dataIndex: "unitOfMeasurement",
      key: "unitOfMeasurement",
      fixed: "left" as "left",
    },
    {
      title: "Кол-во",
      dataIndex: "total",
      key: "total",
      fixed: "left" as "left",
    },
    {
      title: "Выдано",
      dataIndex: "given",
      key: "given",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Цена",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Цена со скидкой",
      dataIndex: "priceDiscounted",
      key: "priceDiscounted",
    },
    {
      title: "Скидка",
      dataIndex: "discount",
      key: "discount",
      render: (discount: number) => `${discount}%`,
    },
    {
      title: "Сумма",
      dataIndex: "totalCost",
      key: "totalCost",
    },
    {
      title: "Клиент",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Причина откаха",
      dataIndex: "rejectReason",
      key: "rejectReason",
    },
    {
      title: "Дата загатовки",
      dataIndex: "tanningDate",
      key: "tanningDate",
    },
    {
      title: "Дата выдачи",
      dataIndex: "givenDate",
      key: "givenDate",
    },
    {
      title: "Пользователь",
      dataIndex: "ownerName",
      key: "ownerName",
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title>Архив Задачи-Заказы</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />

      <Table
        columns={columns}
        dataSource={orders}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </div>
  );
}
